import React, { useMemo, useState } from 'react'
import LayoutForm from '../../../containers/layouts/LayoutForm'
import { Alert, Card, CardBody } from 'react-bootstrap'
import { Header } from '../../../components/Containers/Header'
import { Lista, Option, ModalPathological } from './components'
import { activarModalGenerico, clearActivePathological } from '../../../store/slices/uiSlice'
import { useDispatch } from 'react-redux'
import { ACTIONS, modules, PERMISSIONS } from '../../../constants'
import { toastAdapter } from '../../../plugins'
import {
  useAddPathologicalDiseaseMutation,
  useUpdatePathologicalDiseaseMutation
} from '../../../services/rtk-query'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { genericFormSchema } from '../../../utils'
import { usePermissions } from '../../../hooks'

export const PatologiasPage = () => {
  const { hasPermission } = usePermissions()
  const dispatch = useDispatch()
  const [action, setAction] = useState(ACTIONS.SAVE)
  const [addPathologicalDiasease] = useAddPathologicalDiseaseMutation()
  const [updatePathologicalDisease] = useUpdatePathologicalDiseaseMutation()
  const {
    handleSubmit,
    formState: { errors },
    control,
    reset,
    setValue,
    getValues
  } = useForm({
    resolver: yupResolver(genericFormSchema),
    defaultValues: {
      nombre: '',
      id: 0
    }
  })
  const columns = useMemo(
    () => [
      {
        header: 'id',
        accessorKey: 'id'
      },
      {
        header: 'nombre',
        accessorKey: 'nombre'
      },
      {
        header: 'Activo',
        accessorKey: 'activo',
        cell: ({ row: { original } }) =>
          original.activo ? (
            <Alert
              variant="primary"
              className="text-center d-flex justify-content-center align-items-center"
              style={{
                width: '5rem',
                height: '2rem'
              }}
            >
              Si
            </Alert>
          ) : (
            <Alert
              variant="danger"
              className="text-center d-flex justify-content-center align-items-center"
              style={{
                width: '5rem',
                height: '2rem'
              }}
            >
              No
            </Alert>
          )
      },
      {
        header: 'Opciones',
        accessorKey: 'id',
        cell: ({ row: { original } }) => (
          <Option
            cell={original.id}
            setAction={setAction}
            activo={original.activo}
            hasPermission={!hasPermission([PERMISSIONS.WRITE], modules.patologias)}
          />
        )
      }
    ],
    []
  )
  const handler = () => {
    dispatch(activarModalGenerico())
  }

  const handlerAction = (data) => {
    if (action === ACTIONS.SAVE) return handleSave(data)

    return handleUpdate(data)
  }

  const handleSave = (data) => {
    const { id, ...rest } = data
    toastAdapter.promise({
      promise: addPathologicalDiasease(rest).unwrap(),
      successMessage: () => {
        reset()

        return 'Patologia guardado con éxito'
      },
      errorMessage: (err) => {
        console.log(err)
        return 'Error al guardar la Patologia '
      },
      loadingMessage: 'Guardando Patologia ...'
    })
  }

  const handleUpdate = (data) => {
    toastAdapter.promise({
      promise: updatePathologicalDisease({
        ...data,
        id: +getValues('id')
      }).unwrap(),
      successMessage: () => {
        reset()
        setAction(ACTIONS.SAVE)
        dispatch(clearActivePathological())
        return 'Patologia  guardado con éxito'
      },
      errorMessage: 'Error al guardar la Patologia ',
      loadingMessage: 'Guardando Patologia ...'
    })
  }
  const handleReset = () => {
    reset()
    setAction(ACTIONS.SAVE)
    dispatch(clearActivePathological())
  }

  return (
    <LayoutForm title="Patologias">
      <Card className="shadow-none">
        <Header
          title="Patologias"
          subtitle="Listado de Patologias  registradas en el sistema."
          buttonTitle="Nueva Patologia "
          handler={handler}
          hasPermission={!hasPermission([PERMISSIONS.WRITE], modules.patologias)}
        />
        <CardBody>
          <Lista columns={columns} />
        </CardBody>
      </Card>
      <ModalPathological
        Menstruales
        action={action}
        control={control}
        errors={errors}
        handlerAction={handlerAction}
        handleSubmit={handleSubmit}
        reset={handleReset}
        setValue={setValue}
      />
    </LayoutForm>
  )
}
